import {
    FETCH_KEYWORD, 
    FETCH_KEYWORD_WITH_FILTER, 
    ALL_RESULT_COUNTRY, 
    USER_SEARCHES,
    SAVED_AUTHORS 
 } from '../actions/types';

const initialState = {
    allAuthors: [],
    keyword: "cgd",
    isFetching: false,
    filter: {
        country: {value:'All', label: 'All'},
        yearLimit: {value:0, label:'Anytime'},
        totalLimit: {value: 200, label: '200'},
    },
    userSearches: [],
    savedAuthors: [],
    aggregateAuthors: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_KEYWORD:
            return {
                ...state,
                allAuthors: action.payload.result,
                keyword: action.payload.keyword
            }
            break;
        case FETCH_KEYWORD_WITH_FILTER:
            return {
                ...state,
                allAuthors: action.payload.result,
                keyword: action.payload.keyword,
                filter: {
                    ...state.filter,
                    yearLimit: action.payload.yearLimit,
                    totalLimit: action.payload.totalLimit
                }
            }
            break;
        case ALL_RESULT_COUNTRY:
            return {
                ...state,
                keyword: action.payload.keyword,
                filter: {
                    ...state.filter,
                    country: action.payload.country
                }
            }
            break;
        case USER_SEARCHES:
            return {
                ...state,
                userSearches: action.payload.userSearches
            }
            break;
        case  SAVED_AUTHORS:
            return {
                ...state,
                savedAuthors: action.payload.savedAuthors
            }
            break;
        case 'FETCH_KEYWORD_AGGREGATION':
            return {
                ...state,
                aggregateAuthors: action.payload.result
            }
        default:
            return state;
            break;
    }
}